import { createFrontendModule } from '@backstage/frontend-plugin-api';
import { EntityCardBlueprint } from '@backstage/plugin-catalog-react/alpha';

export const createApiModule = createFrontendModule({
  pluginId: 'app',
  extensions: [
    EntityCardBlueprint.make({
      name: 'api-actions',
      params: {
        filter: 'kind:component',
        type: 'info',
        loader: () =>
          import('./ApiActionsCard').then(m => <m.ApiActionsCard />),
      },
    }),
  ],
});
